import { createContext } from 'react';

import type { IFundRequestContext } from '../DialogFundRequest.helpers';

export const FundRequestContext = createContext<IFundRequestContext | null>(null);
